var ProductsAttributes = $.extend(false, BaseModule ,{

    api_route : 'catalogue/attributes',
	
	data : {
        module      : 'products-attributes',
        page        : 1,
        limit       : 40,
        sort_term   : 'id',
        sort_way    : 'DESC'
    },
    init:function(){
        "use strict";
        var module_name = this.data.module,
            module = this;
    }

});

$(document).ready(function(){
    "use strict";
	ProductsAttributes.init();
});
